import React, {useEffect} from "react";
import ReportUtils from "../../../../../utils/report-utils.js";
import ReportChart from "../../../../../components/reports/charts/report-chart.jsx";
import {createBarChart, createHorizontalBarChart} from "../../../../../components/reports/charts/utils.js";
import CardsContent from "./cards-content.jsx";
import IndividualProfileContent from "./individual-profile-content.jsx";
import VehiclesProfileContent from "./vehicles-profile-content.jsx";
import {
  createNaturesWeekChart,
  createNeighborhoodNatureChart,
  createOccurrencesByDayChart,
  exportCards,
  exportIndividualProfile,
  exportVehicleProfile,
  reportsInfo,
  translateStatus
} from "../../utils/occurrence-dashboard-utils.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const ReportContent = ({data, collapsed}) => {
  const navigate = navigateHook();

  const occurrencesByDayInfo = {
    ...reportsInfo.occurrencesByDay,
    reportName: (data?.occByDay?.length ?? 0) > 31 ? "Ocorrências por semana" : "Ocorrências por dia"
  };

  useEffect(() => {
    ReportUtils.withoutContentReadjust();
  }, [data]);

  useEffect(() => {
    if (!data) return;

    exportCards(data.cards);

    createHorizontalBarChart({
      data: data.statusOcc ?? [],
      reportInfo: reportsInfo.status,
      labelKey: "status"
    });

    createOccurrencesByDayChart(data.occByDay ?? [], occurrencesByDayInfo);
    createNeighborhoodNatureChart(data.occByNeighborhood_Nature ?? [], reportsInfo.neighborhoodNature);

    createBarChart({
      data: data.occurrencesNatures ?? [],
      reportInfo: reportsInfo.natures,
      labelFieldName: "nature",
      limit: 5
    });

    createNaturesWeekChart(data.occByNatures_Week ?? [], reportsInfo.naturesWeek);

    createBarChart({
      data: data.individualsConditions?.map(item => ({label: ReportUtils.formatText(item.classif), qty: item.qty})) ?? [],
      reportInfo: reportsInfo.individualConditions,
      labelFieldName: "label",
      limit: 5
    });

    exportIndividualProfile(data.individualsProfile ?? []);

    createBarChart({
      data: data.vehicleClassification?.map(item => ({label: translateStatus(item.classif), qty: item.qty})) ?? [],
      reportInfo: reportsInfo.vehicleClassification,
      labelFieldName: "label",
      limit: 5
    });

    exportVehicleProfile(data.vehiclesProfile ?? []);
  }, [data, collapsed]);

  return (
    <>
      <div id="general">
        <div className="report-divisor">
          <span className="divisor-title">VISÃO GERAL
            <a className="sub-title-info hover:text-[#1588F3] cursor-pointer print:hidden" onClick={() => navigate("/reports/occurrence_mapping", true)}>Acessar Mapeamento de ocorrências</a>
          </span>
        </div>
        <CardsContent key={`cards-${collapsed}`} data={data?.cards}/>
        <ReportChart key={`status-${collapsed}`} reportInfo={reportsInfo.status} type="horizontal"/>
        <ReportChart key={`by-day-${collapsed}`} reportInfo={occurrencesByDayInfo}/>
        <ReportChart key={`neighborhood-nature-${collapsed}`} reportInfo={reportsInfo.neighborhoodNature} limit={5} dataLength={data?.occByNeighborhood_Nature?.length}/>
      </div>

      <div id="natures">
        <div className="report-divisor mt-7 mb-3">
          <span className="divisor-title">NATUREZAS
            <a className="sub-title-info hover:text-[#1588F3] cursor-pointer print:hidden"  onClick={() => navigate("/reports/occurrence_reasons", true)}>Acessar Ocorrências por naturezas</a>
          </span>
        </div>
        <ReportChart key={`natures-${collapsed}`} reportInfo={reportsInfo.natures} limit={5} dataLength={data?.occurrencesNatures?.length}/>
      </div>

      <ReportChart key={`natures-week-${collapsed}`} reportInfo={reportsInfo.naturesWeek} limit={5} dataLength={data?.occByNatures_Week?.length}/>

      <div id="individuals">
        <div className="report-divisor mt-7 mb-3">
          <span className="divisor-title">INDIVÍDUOS
            <a className="sub-title-info hover:text-[#1588F3] print:hidden cursor-pointer"  onClick={() => navigate("/reports/occurrences_details", true)}>Acessar Detalhamento de ocorrências com indivíduo</a>
          </span>
        </div>
        <ReportChart key={`individual-conditions-${collapsed}`} reportInfo={reportsInfo.individualConditions} limit={5} dataLength={data?.individualsConditions?.length}/>
      </div>

      <IndividualProfileContent key={`individual-profile-${collapsed}`} data={data}/>

      <div id="vehicles">
        <div className="report-divisor mt-7 mb-3">
          <span className="divisor-title">VEÍCULOS
            <a className="sub-title-info hover:text-[#1588F3] print:hidden cursor-pointer"  onClick={() => navigate("/reports/occurrence_associated_vehicles", true)}>Acessar Veículos associados a ocorrências</a>
          </span>
        </div>
        <ReportChart key={`vehicle-classification-${collapsed}`} reportInfo={reportsInfo.vehicleClassification} limit={5} dataLength={data?.vehicleClassification?.length}/>
      </div>

      <VehiclesProfileContent key={`vehicle-profile-${collapsed}`} data={data}/>
      <div id="chart-tables"/>
    </>
  );
};

export default ReportContent;
